<template>
    <div class="accountSettings">
        <!-- <div class="tabs">
            <div v-for="item in pageData.tabs.list" :class="item.type == pageData.tabs.type ? 'active' : ''" :key="item"
                @click="tabsClick(item.type)">
                {{ item.name }}
            </div>
        </div> -->
        <personal v-if="pageData.userInformation.isPersonalAuthentication == 1" />
        <enterprise v-else />
        <!-- <enterprise /> -->
    </div>
</template>

<script>
import { reactive , onMounted } from "vue";
import personal from '@/components/accountSettings/personal'
import enterprise from '@/components/accountSettings/enterprise'
import Cookies from "js-cookie";

import {
    getUserInfo
} from "../api/interfaceList";

export default {
    components: {
        personal,
        enterprise
    },
    setup() {

        let pageData = reactive({
            userCode:JSON.parse(Cookies.get("userInformation")).userCode,
            userInformation:{
                isPersonalAuthentication:1,
                isEnterpriseAuthentication:1
            },
            tabs: {
                type: 1,
                list: [
                    {
                        name: '个人',
                        type: 1
                    },
                    {
                        name: '企业',
                        type: 2
                    },
                ]
            }
        })
        function tabsClick(e) {
            pageData.tabs.type = e
        }

        function getUserInfoFun() {
            getUserInfo({
                usercode: pageData.userCode
            }).then(res => {
                pageData.userInformation = res.data
            })
        }


        onMounted(() => {
            getUserInfoFun()
        })

        return {
            getUserInfoFun,
            pageData,
            tabsClick
        }
    }
}
</script>
<style lang="scss" scoped>
.accountSettings {
    // width: 1050px;
    background: #ffffff;
    border-radius: 8px;
    padding: 16px 30px;
    box-sizing: border-box;
    text-align: left;

    .tabs {
        border-bottom: 1px #f5f5f5 solid;
        margin-bottom: 16px;
        height: 64px;
        width: 100%;
        display: flex;
        align-items: center;

        div {
            font-size: 14px;
            font-family: AlibabaPuHuiTiM;
            color: #909399;
            margin-right: 40px;
            font-weight: 700;
            cursor: pointer;
        }

        .active {
            color: #008AEA;
        }
    }

    .pageTitle {
        font-size: 16px;
        font-family: AlibabaPuHuiTiM;
        color: #303133;
        margin-bottom: 24px;
        font-weight: 700;
        display: flex;
        align-items: center;

        span {
            font-size: 13px;
            font-family: AlibabaPuHuiTiM;
            color: #008AEA;
            margin-left: 8px;
            cursor: pointer;
        }
    }

    .container_ {

        // width: 506px;
        padding: 16px 0 100px;
        box-sizing: border-box;

        .buttonView {
            display: flex;
            align-items: center;
            margin-top: 40px;

            div {
                cursor: pointer;
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                font-family: AlibabaPuHuiTiM;
                text-align: center;
                border-radius: 8px;
            }

            div:nth-of-type(1) {
                width: 120px;
                color: #909399;
                border: 1px solid #C0C4CC;
                margin-right: 72px;
            }

            div:nth-of-type(2) {
                width: 240px;
                color: #FFFFFF;
                background: #008AEA;
            }
        }

        .containerItem {
            display: flex;
            align-items: center;
            margin-bottom: 28px;

            .title_ {
                width: 100px;
                height: 24px;
                font-size: 12px;
                font-family: AlibabaPuHuiTiR;
                color: #303133;

                span {
                    color: #CC3F1F;
                }
            }

            .content_ {
                font-size: 13px;
                font-family: AlibabaPuHuiTiR;
                color: #606266;
            }

            .container_ {
                width: 432px;
            }
        }

        .idCardWap {
            width: 452px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .item {
                width: 144px;
                height: 96px;

                .img_ {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    position: relative;
                    justify-content: center;

                    input {
                        width: 100%;
                        height: 100%;
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 1;
                        opacity: 0;
                    }

                    img {
                        height: 100%;
                        //   position: absolute;
                        //   top: 0;
                        //   left: 0;
                    }
                }
            }
        }

        .expiryDateWap {
            display: flex;
            justify-content: space-between;
            align-items: center;

            div:nth-of-type(1) {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-right: 10px;
            }

            div:nth-of-type(2) {
                width: 250px;
            }
        }

        .selectFourWap {
            display: flex;
            justify-content: space-between;
            align-items: center;

            div {
                width: 100px;
                margin-right: 10px;
            }

            div:last-of-type {
                margin: 0;
            }
        }

    }
}
</style>
